export const HOW_TO_TAP_LINK = "https://iyk.app/how-to-tap"
export const SHIPPING_AND_RETURN_LINK = "https://assets.iyk.app/shipping-and-return.pdf"
export const IYK_MAIL = "help@iyk.app"

const TERMS_AND_SERVICES_URL = "https://assets.iyk.app/iyk-terms-of-service.pdf"
const PRIVACY_POLICY_URL = "https://assets.iyk.app/iyk-privacy-policy.pdf"

export const IYK_URL = "https://iyk.app"

const DISCORD_URL = "https://discord.gg/ezppV2nj7w"
const TWITTER_URL = "https://twitter.com/iyk_app"
const INSTAGRAM_URL = "https://instagram.com/iyk_app"
const TIKTOK_URL = "https://tiktok.com/@iyk_app"
const WARPCAST_URL = "https://warpcast.com/iyk"

export const SOCIAL_LINKS = [
  {
    href: TWITTER_URL,
    text: "X (Twitter)",
  },
  {
    href: INSTAGRAM_URL,
    text: "Instagram",
  },
  {
    href: TIKTOK_URL,
    text: "TikTok",
  },
  {
    href: DISCORD_URL,
    text: "Discord",
  },
  {
    href: WARPCAST_URL,
    text: "Farcaster",
  },
]

export const COMPANY_LINKS = [
  {
    href: IYK_URL,
    text: "iyk.app",
  },
  {
    href: PRIVACY_POLICY_URL,
    text: "Privacy",
  },
  {
    href: TERMS_AND_SERVICES_URL,
    text: "Terms",
  },
]
